import { Grid, Card, CardContent, Typography, Box } from "@mui/material";
import { styled } from "@mui/system";
import Header from "src/Component/content-component/Header";

const imageBaseUrl = process.env.REACT_APP_IMAGE_URL;
const icons = [
  "International-Relation/self-improvement.png",
  "International-Relation/economic-activity.png",
  "International-Relation/diversity.png",
  "International-Relation/seo.png",
  "International-Relation/internship.png",
  "International-Relation/enhance.png"
];

const benefits = [
  { title: "Improved Ranking", subtitle: "Enhancing institutional reputation through global ranking frameworks" },
  { title: "Economic Benefits", subtitle: "Driving financial growth and attracting investment" },
  { title: "Diversity", subtitle: "Fostering an inclusive and multicultural environment" },
  { title: "Expand Research Opportunities", subtitle: "Boosting innovation and academic advancements" },
  { title: "Graduate Employability", subtitle: "Increasing job prospects and career readiness" },
  { title: "Enhancing Global Image", subtitle: "Strengthening international recognition and credibility" }
];

const StyledCard = styled(Card)({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  textAlign: "center",
  padding: "10px",
  width: "100%",
  maxWidth: "260px",
  minHeight: "160px", 
  borderRadius: "12px",
  boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)"
});

const Benefit = () => {
  return (
    <Box
      sx={{
        textAlign: "center",
        mt: 4,
        mb: 5,
        px: { xs: 2, sm: 5, md: 10, lg: 12 }
      }}
    >
      <Header color="#00999e" textAlign="center" content="Benefits" sx={{ mb: 3 }} />
      
      <Grid container spacing={3} justifyContent="center">
        {benefits.map((benefit, index) => (
          <Grid item xs={12} sm={6} md={4} lg={4} key={index} display="flex" justifyContent="center">
            <StyledCard>
              <Box sx={{ fontSize: 40, color: "#008080", mt: 1, mb: 2 }}>
                <img src={`${imageBaseUrl}${icons[index]}`} alt={benefit.title} style={{ width: 60, height: 60 }} />
              </Box>
              <CardContent sx={{ flexGrow: 1 }}>
                <Typography variant="body1" fontWeight="bold">
                  {benefit.title}
                </Typography>
                <Typography variant="body2" sx={{ color: "gray", mt: 1 }}>
                  {benefit.subtitle}
                </Typography>
              </CardContent>
            </StyledCard>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Benefit;
